export default __webpack_public_path__ + "static/media/Policy_Status.34bf139c.png";